import React from 'react';
import { PaginatorProvider } from 'src/context/PaginatorContext';
import { RealEstateProperties } from 'src/Components/RealEstateProperties';
var RealEstatePropertiesPage = function () { return (React.createElement(PaginatorProvider, null,
    React.createElement(RealEstateProperties, null))); };
export default RealEstatePropertiesPage;
